import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { DialogService } from "@eforall/dashboard";
import { PersonDialog } from "../../../../../ui/widget/person-dialog";
import { VolunteerDialogDataService } from "../volunteer-dialog-data.service";
import { LeadVolunteerOverviewContentDialogPart } from "./lead-volunteer-overview/lead-volunteer-overview-content-dialog.part";
import { VolunteerOverviewContentDialogPart } from "./volunteer-overview/volunteer-overview-content-dialog.part";

@Component({
	selector: 'volunteer-application-overview-content-dialog-part',
	standalone: true,
	imports: [
		LeadVolunteerOverviewContentDialogPart,
		VolunteerOverviewContentDialogPart
	],
	templateUrl: './overview-content-dialog.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [``]
})
export class OverviewContentDialogPart {

	private readonly dialog = inject(DialogService);
	private readonly dialogDataService = inject(VolunteerDialogDataService);
	public readonly volunteerDetails = computed(() => this.dialogDataService.volunteerDetails());

	// Signal to track which view to show: 'lead' or 'approved'
	public readonly currentView = computed<'lead' | 'volunteer'>(this.dialogDataService.overviewContentView);

	async openPersonDialog(personId: number) {
		await this.dialog.showCustom(PersonDialog, { data: { personId, toEdit: false } }, 800, 800);
	}

}